import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Keeping a Notebook`}</h1>
    <p>{`Like many other web developers, I’ve built myself a blog more than once, then didn’t write in it.`}</p>
    <p>{`I started keeping my `}<a parentName="p" {...{
        "href": "/"
      }}>{`Notebook`}</a>{` about a month ago. It’s definitely the most continuous blog I’ve ever kept.`}</p>
    <p>{`With other blogs, I internally would set this high bar that everything on my blog needed to be perfect—a long-lasting, authoritative institution of a webpage. Why would I want to publish something that’s not perfect?`}</p>
    <p>{`(Because I don’t have time or care enough for that!)`}</p>
    <p>{`The Notebook format is just like publishing GitHub Gists. They’re self-contained, Markdown-files-turned-webpages.`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup></p>
    <p>{`With Notebook, I often publish a post within 30 minutes of thinking of it. I open `}<a parentName="p" {...{
        "href": "https://getdrafts.com"
      }}>{`Drafts`}</a>{`, start writing, re-read/edit, then `}<a parentName="p" {...{
        "href": "https://notebook.lachlanjc.me/2019-09-05_publishing_notebook_in_mdx_via_ipad/"
      }}>{`publish`}</a>{`.`}<sup parentName="p" {...{
        "id": "fnref-2"
      }}><a parentName="sup" {...{
          "href": "#fn-2",
          "className": "footnote-ref"
        }}>{`2`}</a></sup></p>
    <p>{`Sometimes I want to write about how `}<a parentName="p" {...{
        "href": "https://notebook.lachlanjc.me/2019-09-05_windy_city_hacks_newsletters/"
      }}>{`I’m a big iPad nerd`}</a>{`. Sometimes it’s about `}<a parentName="p" {...{
        "href": "https://notebook.lachlanjc.me/2019-09-06_my_websites_look_the_same/"
      }}>{`my design philosophy`}</a>{`. Sometimes it’s `}<a parentName="p" {...{
        "href": "https://notebook.lachlanjc.me/2019-08-23_the_man/"
      }}>{`thoughts on gender experience`}</a>{`. My Notebook isn’t an Apple blog, a design blog, or a gender blog. It’s `}<em parentName="p">{`my place to publish on the internet`}</em>{`.`}</p>
    <p>{`There are no comments, & I don’t feel any judgement about what I post.`}<sup parentName="p" {...{
        "id": "fnref-3"
      }}><a parentName="sup" {...{
          "href": "#fn-3",
          "className": "footnote-ref"
        }}>{`3`}</a></sup>{` I’m not putting my thoughts into the feeds of a thousand people I’m scared of disappointing. I can just be me. If no one reads it, or if a post were to go viral, I don’t especially care either way.`}</p>
    <p>{`There’s a much lower bar to “writing in my notebook” than “publishing on a blog”`}<sup parentName="p" {...{
        "id": "fnref-4"
      }}><a parentName="sup" {...{
          "href": "#fn-4",
          "className": "footnote-ref"
        }}>{`4`}</a></sup>{`—especially when that’s a site I don’t think very many people look at. I can get something out quickly, without feeling like it needs to be perfect. Posts are written exactly the way I speak. They have a date, but no timestamp.`}</p>
    <p>{`If people are curious what I’m thinking about or working on, it’s public here. Or if it’s just a quick document I want to share, I can put that here. Sometimes I write several posts, one after another. I don’t set expectations about what you’ll get or how often or why. It’s just me. This is my Notebook.`}</p>

    <div {...{
      "className": "footnotes"
    }}>
      <hr parentName="div"></hr>
      <ol parentName="div">
        <li parentName="ol" {...{
          "id": "fn-1"
        }}>{`I love being able to publish a decent-looking webpage on my own domain super super easily! `}<a parentName="li" {...{
            "href": "https://www.gatsbyjs.org"
          }}>{`Gatsby`}</a>{` + `}<a parentName="li" {...{
            "href": "https://mdxjs.com/"
          }}>{`MDX`}</a>{` is amazing.`}<a parentName="li" {...{
            "href": "#fnref-1",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
        <li parentName="ol" {...{
          "id": "fn-2"
        }}>{`If I can’t/don’t want to write a post immediately, I keep a short list (in `}<a parentName="li" {...{
            "href": "https://culturedcode.com/things/"
          }}>{`Things`}</a>{`, before someone asks) of ideas. Honestly though, I’m way less likely to write a post if it sits on that list for a bit than if I’ve just had the idea & run with the spark.`}<a parentName="li" {...{
            "href": "#fnref-2",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
        <li parentName="ol" {...{
          "id": "fn-3"
        }}>{`Including the fact that I want to use footnotes kind of often, so I do.`}<a parentName="li" {...{
            "href": "#fnref-3",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
        <li parentName="ol" {...{
          "id": "fn-4"
        }}>{`Though this is pretty roughly a blog, I like `}<a parentName="li" {...{
            "href": "https://jxnblk.com/blog/microbeats-is-the-best-journal-ive-ever-kept/"
          }}>{`@jxnblk on non-traditional journals`}</a>{`.`}<a parentName="li" {...{
            "href": "#fnref-4",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
      </ol>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      